module.exports = __webpack_public_path__ + "img/submitted-icon.a468a3d1.svg";